import { create } from 'zustand';
import { SegSelectOption } from '../../Components/SegUI/SegSelect/SegSelect';
import { createJSONStorage, persist } from "zustand/middleware";
import { Cotizacion } from '../../Pages/Auto/Precios';
import { CotizacionPrepaga } from '../../Pages/Prepaga/Individuo/Precios';
import { CotizacionesAP } from '../../Pages/AP/Precios';
import { esLandingDeVendedor } from '../ventaPresencial/rutaVendedor';

export interface ICotizacionValues {
  patente?: string;
  marca?: SegSelectOption;
  modelo?: SegSelectOption;
  año?: SegSelectOption;
  esAntiguo?: boolean;
  /**
   * Uso del vehículo en la cotización. Hoy ningún paso lo pregunta (el select
   * vive en la revisión de datos de emisión): si está vacío, el contacto manda
   * PARTICULAR, igual que hacía el monolito.
   */
  tipoUso?: SegSelectOption;
  version?: SegSelectOption;
  nombre?: string;
  apellido?: string;
  email?: string;
  telefono?: { prefijo: string; numero: string };
  fechaNac?: { dia: string; mes: string; año: string };
  genero?: SegSelectOption;
  localidad?: SegSelectOption;
  provincia?: SegSelectOption;
  cuandoContrata?: SegSelectOption;
  parametrosIniciales?: any;
  contactoId?: string;
  sumaAseguradaIA?: string;
  sumaAsegurada?: string;
  cotizaciones?: Cotizacion[];
  cotizacionesAP?: CotizacionesAP[];
  cotizacionesPrepaga?: CotizacionPrepaga[];
  fechaConsultaCotizaciones?: Date;
  captchaToken?: string;
  landingUrl?: string,
  /** Venta presencial: vendedor y sucursal fijados al tocar "Empezar a cotizar" en /auto/vendedor. */
  ventaPresencial?: { vendedor: string; sucursal: string };
  referer?: string,
  token?: string;
  /** Vencimiento ISO del JWT de cotización (camino BFF). */
  expiraEn?: string;
  /** Id opaco de la cotización en el BFF (camino BFF). */
  cotizacionId?: string;
  /** Hasta cuándo valen los precios cotizados (ISO, camino BFF). */
  vigenciaHasta?: string;
  /** El datacar no resolvió los ids del vehículo: se carga a mano. */
  vehiculoSinIds?: boolean;
  cuit?: string;
  empleados?: string;
  masaSalarial?: string;
  razonSocial?: string;
  cobertura?: SegSelectOption;
  tipoMoneda?: string;
  tipoDoc?: SegSelectOption;
  numeroDoc?: string;
  derivaAportes?: boolean;
  conyuge?: boolean;
  hijos?: boolean;
  documentoConyuge?: string;
  sueldoBrutoConyuge?: string;
  cantHijos?: SegSelectOption;
  observaciones?: string;
  unificarAportes?: boolean;
  codigoPostal?: string;
  localidadLanding?: string;
  rubro?: string;
  tipoPersona?: string;
  condicionIVA?: string;
  condicionIIBB?: string;
  profesion?:SegSelectOption;
  actividadDedicada?:string|null;
  cantidadDeVidas?:number;
  sumaMuerte?: number;
  fechaInicio?: string;
  fechaFin?: string;
  profesiones?:any[]
}

interface CotizacionStore {
  cotizacionValues: ICotizacionValues;
  setCotizacionValues: (values: ICotizacionValues) => void;
  resetCotizacionValues: () => void;
  vaciarCotizaciones: () => void;
}

export const useCotizacionStore = create<CotizacionStore>()(
  persist(
    (set) => ({
      cotizacionValues: {},
      // Los datos del vendedor solo valen en una cotización que arrancó en /auto/vendedor (US 23866): otro
      // cotizador en la misma pestaña cambia la landing y no los arrastra.
      setCotizacionValues: (values: ICotizacionValues) =>
        set({
          cotizacionValues: {
            ...values,
            ...(values.ventaPresencial && !esLandingDeVendedor(values.landingUrl) && { ventaPresencial: undefined }),
          },
        }),
      resetCotizacionValues: () => set({ cotizacionValues: {} }),
      vaciarCotizaciones: () => set((state) => ({
        ...state,  // Mantén las otras propiedades del objeto padre
        cotizaciones: []
      })),
    }),
    {
      name: "cotizacion",
      storage: createJSONStorage(() => sessionStorage),
    }
  ));